import Vue from 'vue';

let setMaxHeight;

Vue.directive('max-height', {
    bind(el, binding, vnode, oldVnode) {
        setMaxHeight = (evt) => {
            el.style['max-height'] = `${window.innerHeight}px`;
            // vnode.context.$nextTick(() => {
            //     console.log('>>>', vnode.elm.parentElement.clientWidth, window.innerHeight);
            //     el.style.height = vnode.elm.parentElement.clientWidth; //'500px';
            // });
        }
        setMaxHeight();
        window.addEventListener('resize', setMaxHeight);
    },
    unbind: function (el, binding, vnode) {
        window.removeEventListener('resize', setMaxHeight);
    }
});
